import {requests} from "../../helpers/api.services";
import {NOTIFICATION_URL} from "../../helpers/api.routes";

export const AdminNotificationService = {
    get: (mobileType: string) => requests.get(NOTIFICATION_URL, {mobileType}),
    create: (params: any) => requests.post(`${NOTIFICATION_URL}/send`, params),
};
